import type { Tag, AddTagRequest } from '@/types/tag';
import type { PageResponse } from '@/types/resource';
import { request } from '@/utils/request';

/**
 * 标签管理相关API服务
 */
export default {
  /**
   * 新增标签
   * @param data 标签信息
   * @returns 添加结果
   */
  async addTag(data: AddTagRequest): Promise<Tag> {
    const response = await request.post('/tags', data);
    return response.data;
  },

  /**
   * 删除标签
   * @param id 标签ID
   */
  async deleteTag(id: number): Promise<void> {
    await request.delete(`/tags/${id}`);
  },

  /**
   * 获取标签详情
   * @param id 标签ID
   * @returns 标签详情
   */
  async getTagById(id: number): Promise<Tag> {
    const response = await request.get(`/tags/${id}`);
    return response.data;
  },

  /**
   * 获取所有标签
   * @param page 页码
   * @param size 每页大小
   * @returns 标签列表
   */
  async getTags(page = 1, size = 20): Promise<PageResponse<Tag>> {
    const response = await request.get('/tags', {
      params: { page, size }
    });
    return response.data;
  },

  /**
   * 根据名称搜索标签
   * @param name 标签名称
   * @param page 页码
   * @param size 每页大小
   * @returns 标签列表
   */
  async searchTags(name: string, page = 1, size = 10): Promise<PageResponse<Tag>> {
    const response = await request.get('/tags/search', {
      params: { name, page, size }
    });
    return response.data;
  }
}; 